import "./ShowMoreButton.scss";

interface ShowMoreButtonProps {
  isOpen: boolean;
  onClick: () => void;
  moreLabel: string;
  lessLabel: string;
}

const ShowMoreButton = ({
  isOpen,
  onClick,
  moreLabel,
  lessLabel,
}: ShowMoreButtonProps) => {
  return (
    <div className="viewMoreWrap fi">
      <button
        className={`btnViewMore ${isOpen ? "open" : ""}`}
        onClick={onClick}
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M4 6l4 4 4-4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
        {isOpen ? lessLabel : moreLabel}
      </button>
    </div>
  );
};

export default ShowMoreButton;
